// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {

	if ($('dl.accordion dt').length > 0) {

		$("dl.accordion dt").click(function () {
			$(this).next("dd").slideToggle();
			$(this).toggleClass("is_open");
		});
	}
});


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.c-hamburger').length > 0) {
		$('.c-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is_open');
				nav.removeClass('is_close');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.c-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.c-hamburger:visible').length > 0) {
				$('.c-hamburger').click();
			}
		});
	}
});


// モーダルウィンドウ // Modal window
document.addEventListener("DOMContentLoaded", function () {
	if (window.innerWidth > 768) {
		MicroModal.init({
			disableScroll: true,
			awaitOpenAnimation: true,
			awaitCloseAnimation: true,
		});
	}
});


// お問い合わせフォームにあるプライバシーポリシー
// TOPとお問い合わせページでリンク先を変更
document.addEventListener("DOMContentLoaded", function () {
	var isTopPage = window.location.pathname === '/' || window.location.pathname === '/kotobani/wp/';
	var bottomAgree = document.getElementById('bottomAgree');

	// bottomAgreeElementが存在する場合にのみ処理を行う
	if (bottomAgree) {
		var htmlContent = '<p class="bottom_agree"><span class="essential">必須</span><a href="' + (isTopPage ? './privacy/' : '../privacy/') + '" target="_blank">個人情報の取り扱いについて</a></p>';
		bottomAgree.innerHTML = htmlContent;
	}
});